import React from 'react';
import '../../../../../styles/popUp.scss'
const Security2FaPopUp = ({setIsOpen, setIsEnable}) => {

    const hendlerCloseAndEnalble = () => {
        setIsOpen(false)
        setIsEnable(true)
    }
    return (
        <div className='pop_up_wrap'>
            <div className='pop_up_content'>
                <button className='btn btn_prime btn_close_pop_up' onClick={hendlerCloseAndEnalble}>X</button>
                <div className='pop_up_content_header'>
                    <h3>2FA Settings</h3>
                    <p> Make your experience safer in 3 easy steps:</p>
                </div>
                <div className='pop_up_content_body'>
                    <div className='pop_up_content_body_item'>
                            <div className='pop_up_img_wrap'>
                            <img src="/img/google.svg" alt="" />
                            </div>
                            <div className='pop_up_content_body_item_text'>
                                <h4>Download an Authenticator App</h4>
                                <p>Download and install <span>Authy</span> or  <span>Google</span> <span>Authenticator</span> for your phone or tablet.</p>
                            </div>
                    </div>
                    <div className='pop_up_content_body_item'>
                             <div className='pop_up_img_wrap'>
                                <img src="/img/qr code.svg" alt="" />
                            </div>
                            
                            <div className='pop_up_content_body_item_text'>
                                <h4>Scan QR code </h4>
                                <p>Open the authentication app and scan the image to the left using your phone’s camera.</p>
                                <h4>2FA Key (Manual Entry)</h4>
                                <div className='fa_key_manual'><p>3had rkka 59ha kkke</p></div>
                            </div>
                    </div>
                    <div className='pop_up_content_body_item'>
                            <div className='pop_up_img_wrap'>
                                <img src="/img/code.svg" alt="" />
                            </div>
                           
                            <div className='pop_up_content_body_item_text'>
                                <h4>Login with your code</h4>
                                <p>Enter the 6-digit verification code generated.</p>
                                <div className='login_with_you_code'>
                                    <div className='fa_key_manual'>
                                        <p>8372 9184</p>
                                    </div>
                                    <button className='btn btn_prime'>Verify</button>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Security2FaPopUp;